<mat-expansion-panel class="catalog-expansion-panel" [disabled]="disabled">
    <mat-expansion-panel-header>
        <h2>{{title}}</h2>
    </mat-expansion-panel-header>
    <div class="mobile-date-filter">
        <app-custom-datepicker class="first-picker" [placeholder]="startDatePlaceHolder" [selectedDate]="fromDate" [disabled]="disabled"
            (dateChange)="changeDateFrom($event)"></app-custom-datepicker>
        <app-custom-datepicker [placeholder]="endDatePlaceHolder" [selectedDate]="toDate" [disabled]="disabled" 
            (dateChange)="changeDateTo($event)"></app-custom-datepicker>
    </div>
</mat-expansion-panel>